import axios from 'axios';
import {REACT_APP_API_SERVER, TOKEN_KEY} from '../constants';

// Define base API url (based on the environment)
export const DEFAULT_API_URL = REACT_APP_API_SERVER;

// If token exist - Build auth header (Bearer auth)
export const getAuthHeader = () => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) {
    return `Bearer ${token}`;
  }
  return '';
};

// Creating axios request instance
const api = axios.create({
  baseURL: DEFAULT_API_URL,
  // Adding headers to skip ngrok browser warning - This is useful when using ngrok for local development
  headers: {
    'ngrok-skip-browser-warning': '1'
  },
  // Setting 20 sec timeout for requests
  timeout: 20000,
});

// Attach a request interceptor to automatically add the Authorization header
//  (if a token exists) to every outgoing API request
api.interceptors.request.use((config) => {
  const authHeader = getAuthHeader();
  if (authHeader) {
    config.headers.Authorization = authHeader;
  }
  return config;
});

export default api;
